import {
    JCENVIRO_GET_EWC_CODES,
    JCENVIRO_ADD_EWC_CODE,
    JCENVIRO_REMOVE_EWC_CODE
} from "./types";
import firebase from "firebase/app";
export const getEWCList = () => {
    return dispatch => {
        dispatch({ type: JCENVIRO_GET_EWC_CODES.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: JCENVIRO_GET_EWC_CODES.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/ewc")
                        .on("value", snapshot => {
                            dispatch({
                                type: JCENVIRO_GET_EWC_CODES.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: JCENVIRO_GET_EWC_CODES.FAIL });
        }
    };
};
export const setEWCCode = ewcCode => {
    return dispatch => {
        dispatch({ type: JCENVIRO_ADD_EWC_CODE.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: JCENVIRO_ADD_EWC_CODE.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/ewc")
                        .child(ewcCode.ewc_code)
                        .set(ewcCode);
                    dispatch({
                        type: JCENVIRO_ADD_EWC_CODE.SUCCESS
                    });
                }
            });
        } catch (e) {
            dispatch({ type: JCENVIRO_ADD_EWC_CODE.FAIL });
        }
    };
};

export const removeEWCCode = key => {
    return dispatch => {
        dispatch({ type: JCENVIRO_REMOVE_EWC_CODE.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({
                        type: JCENVIRO_REMOVE_EWC_CODE.FAIL
                    });
                } else {
                    firebase
                        .database()
                        .ref("/collections/ewc")
                        .child(key)
                        .remove();
                    dispatch({ type: JCENVIRO_REMOVE_EWC_CODE.SUCCESS });
                }
            });
        } catch (e) {
            dispatch({ type: JCENVIRO_REMOVE_EWC_CODE.FAIL });
        }
    };
};
